import React from 'react';
import { Helmet } from 'react-helmet';
import SalesReportChart from '../components/SalesReportChart';
import OrdersOverviewChart from '../components/OrdersOverview';

function Reports() {
  return (
    <>
      <Helmet><title>Reports & Analytics | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Reports & Analytics</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Reports</p>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-md-12 p-b-15">
              <div id="user-acquisition" className="card card-default">
                <div className="card-header"><h2>Sales Report</h2></div>
                <div className="card-body">
                  <div className="mb-6" style={{ maxHeight: '247px' }}>
                    <SalesReportChart />
                    <div id="acqLegend" className="customLegend mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-12 p-b-15">
              <div className="card card-default">
                <div className="card-header justify-content-center"><h2>Orders Overview</h2></div>
                <div className="card-body"><OrdersOverviewChart /></div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-xl-6 col-md-12">
              <div className="card card-default">
                <div className="card-header"><h2>Top Categories</h2></div>
                <div className="card-body">
                  <ul className="list-group">
                    <li className="list-group-item d-flex justify-content-between align-items-center">Apparel <span className="badge bg-primary rounded-pill">35%</span></li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">Footwear <span className="badge bg-primary rounded-pill">22%</span></li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">Electronics <span className="badge bg-primary rounded-pill">18%</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12">
              <div className="card card-default">
                <div className="card-header"><h2>KPIs</h2></div>
                <div className="card-body">
                  <div className="row text-center">
                    <div className="col-6"><h3>4.2%</h3><p>Conversion Rate</p></div>
                    <div className="col-6"><h3>$58.24</h3><p>Avg. Order Value</p></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;
